import React from 'react'
import { Text, SummaryExercise, Heading } from 'components/library'
import pdf from './assets/5c8a1c4bfe36da2d5e24d52d-1555063137384-H4_Assistentie_en_begeleiding_in_de_praktijk_SLEEP.pdf'

const Intro = props => (
	<div>
		<Text><strong>In dit hoofdstuk leer je:</strong></Text>
		<ul style={{marginTop: '0'}}>
			<li>aan welke voorwaarden begeleiding moet voldoen;</li>
			<li>hoe het begeleidingsproces verloopt bij verschillende soorten defecten;</li>
			<li>wat je moet doen als je opgeroepen wordt voor assistentie.</li>
		</ul>
	</div>
)

const Summary = props => (
	<div>
		<div>
			<ul style={{marginTop: '0'}}>
				<li>aan welke voorwaarden begeleiding moet voldoen;</li>
				<li>wat de procedure is voor het begeleiden tijdens een defect anti-collisionlight, transponder en breekbout;</li>
				<li>wat je moet doen als je opgeroepen wordt voor assistentie.</li>
			</ul>
		</div>

		<div>
			<SummaryExercise link={pdf}>
				<Heading h3>Assistentie en begeleiding in de praktijk</Heading>
		    <ul style={{marginTop: '0'}}>
		      <li>Ga samen met je instructeur eens bij een begeleidingsvoertuig kijken. Kun je zien of het voertuig aan alle voorwaarden voldoet?</li>
		      <li style={{margin: '3rem 0'}}>Vraag eens aan een collega die begeleiding heeft ontvangen hoe dit in zijn werk ging. Herken je de stappen uit de begeleidingsprocedure?</li>
		      <li>Ga samen met je instructeur eens langs bij Apron Control. Vraag hen eens of ze meer kunnen vertellen over de begeleidingsprocedure. Vraag ook meteen eens in welke situaties Apron Control je kan vragen je gereed te houden voor assistentie.</li>
		    </ul>
			</SummaryExercise>
		</div>
  </div>
)

export { Intro, Summary }



// WEBPACK FOOTER //
// ./src/content/chapters/04/index.js